// CSS
import calendarCss from "./calendar.css";
import toastCss from "../../styles/toast.css";
import { html, nothing, TemplateResult } from "lit";
import { MSSchedule } from ".";
import { CheckboxChangeEvent, ScheduleAction, ScheduleItem } from "@lib/types";
import { classMap } from "lit/directives/class-map.js";
import moment from "moment";

type EventActionsMenuOptions = Readonly<{
    isSingle: boolean;
    isEnabled: boolean;
}>;

export const calendarContextMenu = (): string => `
    <div class="popup-content event-actions" style="background: #fff; width: 240px">
        <ul class="popup-items">
            <li id="create">Добавить событие</li>
        </ul>
    </div>
`;

export const eventActionsMenuPopup = (options: EventActionsMenuOptions): string => `
    <div class="popup-content event-actions" style="background: #fff; width: 240px">
        <ul class="popup-items">
            <li id="edit">Редактировать ${options.isSingle ?
                "событие" :
                "ряд событий"}</li>
            <li id="delete">Удалить ${options.isSingle ?
                "событие" :
                "ряд событий"}</li>
            <li id="enable">${options.isEnabled ?
                "Деактивировать" :
                "Активировать"} ${options.isSingle ?
                "событие" :
                "ряд событий"}</li>
        </ul>
    </div>
`;

export const popupContextMenuEvent = (): string => ` 
    <div class="popup-content" style="background: #fff;">
        <ul class="popup-items">
            <li id="single-event" class="expandable">Событие</li>
            <li id="row-events" class="expandable">Ряд событий</li>
        </ul>
    </div>
`;

export const popupSelectEvent = (item: ScheduleItem, time: string, parameterName: string, isParameterFound: boolean): string => `
    <style>
        .square {
            width: 12px;
            height: 12px;
        }

        .popup-view-wrapper {
            padding: 10px;
            min-width: 400px;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        .popup-view-header {
            display: flex;
            justify-content: space-between;
        }

        .popup-view-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
        }

        .popup-view-footer {
            display: flex;
            justify-content: end;
            gap: 10px;
        }

        .name {
            margin: 0;
        }

        .parameter-not-found {
            color: #d72d30;
        }

        .time-row {
            display: flex;
            align-items: center;
            gap: 5px;
        }

        .comment {
            display: flex;
            gap: 10px;
            max-width: 600px;
        }

        .bold {
            font-weight: 700;
        }

        #close-icon {
            cursor: pointer;
        }

        #edit button {
            color: #fff;
            background: #345AA4;
        }
    
    </style>

    <div class="popup-content" style="background: #fff;">
        <div class="popup-view-wrapper">
            <div class="popup-view-header">
                <h3 class="name">${item.name}</h3>
                ${cross.strings.toString()}
            </div>
                        
            <div class="popup-view-content">
                <div class="time-row">
                    <div class="square" style="background-color: ${item.color}"></div>
                    <p>${time}, <span ${isParameterFound ?
                        "" :
                        "class='parameter-not-found'"}>
                            ${parameterName}
                        </span>
                        ${item.action.type === ScheduleAction.SetParameter ?
                            `, ${item.action.value}` :
                            ""}
                    </p>
                </div>
                ${
                    item.comment ?
                        `<div class="comment">
                            <p class="bold">Комментарий:</p>
                            <p>${item.comment}</p>
                        </div>` :
                        ""
                }
            </div>
            
            <div class="popup-view-footer">
                <fw-button id="edit" color="primary"> Редактировать </fw-button>
                <fw-button id="delete" color="secondary"> Удалить </fw-button>
            </div>
        </div>
    </div>
`;

export const popupEventsList = (date: Date): string => {
    const parsedDate = moment(date);
    return `
        <style>
            .popup-content_event-list {
                display: flex;
                flex-direction: column;
                width: 100%;
                flex: 1;
            }
            .title {
                padding: 12px;
            }
            .title-date {
                color: #333;
                font-size: 18px;
            }
            .title-day {
                color: #333;
                font-size: 14px;
            }
            .events-list {
                padding: 12px;
                margin: 0;
                list-style-type: none;
                display: flex;
                flex-direction: column;
                min-width: 250px;
                overflow: auto;
                box-sizing: border-box;
                flex: 1;
            }
            .item {
                font-size: 12px;
                font-weight: 700;
                cursor: pointer;
                padding: 5px 0;
                display: flex;
                align-item: center;
                gap: 5px;
            }
            .item__marker {
                background-color: var(--marker-color);
                width: 12px;
                height: 12px
            }
            .parameter-not-found {
                color: #d72d30;
            }
        </style>
        <div class="popup-content popup-content_event-list" style="background: #fff;">
            <div class="title">
                <span class="title-date">${parsedDate.format("DD")}</span>
                <span class="title-day">${parsedDate.format("ddd")}</span>  
            </div>
            <ul class="events-list">
            </ul>
        </div>
    `;
};

const arrow = html`
    <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 292.359 292.359"
        style="enable-background:new 0 0 292.359 292.359;"
        xml:space="preserve"
    >
        <g>
            <path
                d="M222.979,5.424C219.364,1.807,215.08,0,210.132,0c-4.949,0-9.233,1.807-12.848,5.424L69.378,133.331
        c-3.615,3.617-5.424,7.898-5.424,12.847c0,4.949,1.809,9.233,5.424,12.847l127.906,127.907c3.614,3.617,7.898,5.428,12.848,5.428
        c4.948,0,9.232-1.811,12.847-5.428c3.617-3.614,5.427-7.898,5.427-12.847V18.271C228.405,13.322,226.596,9.042,222.979,5.424z"
            />
        </g>
    </svg>
`;

const cross = html`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        tabindex="0"
        id="close-icon"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.00024 5.40694L9.48633 9.29488L9.88915 8.83008L5.46981 
        4.99998L9.88915 1.16988L9.48633 0.705078L5.00024 4.59302L0.514155 0.705078L0.111328 1.16988L4.53067 
        4.99998L0.111328 8.83008L0.514155 9.29488L5.00024 5.40694Z"
            fill="black"
        />
    </svg>
`;

/** No need to check SVGs for length. */
/* eslint-disable @stylistic/max-len */
const lockClosed = html`
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.4389 4.39532C12.985 4.81852 13.4291 5.39734 13.7528 6.10494C13.9126 6.51845 14 6.96519 14 7.43087V9.73126H5.77056V7.87086C5.87833 6.45908 6.52603 5.21543 7.52148 4.43751C8.21167 3.91375 9.07068 3.59689 10 3.59689C10.9167 3.59689 11.763 3.89503 12.4389 4.39532ZM4.07955 9.73126V7.87086C4.07955 4.92329 6.74546 2 9.99558 2C11.0589 2 12.0972 2.34339 12.977 2.89254C13.4555 3.18303 13.8857 3.54098 14.2528 3.95206C14.6695 4.40983 14.9958 4.91863 15.199 5.4449C15.4575 6.06021 15.6 6.73065 15.6 7.43087V9.73126H18V22H2V9.73126H4.07955ZM16.4 20.4664V11.2649H3.6V20.4664H16.4Z"
            fill="black"
        />
    </svg>
`;

const lockOpened = html`
    <svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 2.5C7.572 2.5 5.5312 4.01154 4.7 6.05769L6.1752 6.63462C6.7816 5.14154 8.2688 4.03846 10 4.03846C12.2032 4.03846 14 5.76615 14 7.88462V10.1923H2V22.5H18V10.1923H15.6V7.88462C15.6 4.92769 13.0752 2.5 10 2.5ZM3.6 11.7308H16.4V20.9615H3.6V11.7308Z"
            fill="black"
        />
    </svg>
`;

const warning = html`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 40 40" version="1.1">
        <path style=" stroke:none;fill-rule:nonzero;fill:rgb(84.705883%,17.647059%,18.82353%);fill-opacity:1;" d="M 20 1.820312 C 21.121094 1.820312 22.15625 2.425781 22.703125 3.40625 L 39.636719 33.890625 C 39.875 34.320312 40 34.800781 40 35.292969 C 40 36.886719 38.707031 38.179688 37.113281 38.179688 L 2.886719 38.179688 C 1.292969 38.179688 0 36.886719 0 35.292969 C 0 34.800781 0.125 34.320312 0.363281 33.890625 L 17.296875 3.40625 C 17.84375 2.425781 18.878906 1.820312 20 1.820312 Z M 20 3.636719 C 19.550781 3.636719 19.136719 3.878906 18.921875 4.273438 L 1.945312 34.859375 C 1.863281 35.011719 1.820312 35.179688 1.820312 35.351562 C 1.820312 35.910156 2.269531 36.363281 2.828125 36.363281 L 37.171875 36.363281 C 37.730469 36.363281 38.179688 35.910156 38.179688 35.351562 C 38.179688 35.179688 38.136719 35.011719 38.054688 34.859375 L 21.078125 4.273438 C 20.863281 3.878906 20.449219 3.636719 20 3.636719 Z M 21.820312 30.910156 C 21.820312 31.914062 21.003906 32.726562 20 32.726562 C 18.996094 32.726562 18.179688 31.914062 18.179688 30.910156 C 18.179688 29.90625 18.996094 29.09375 20 29.09375 C 21.003906 29.09375 21.820312 29.90625 21.820312 30.910156 Z M 21.820312 25.453125 C 21.820312 26.460938 21.003906 27.273438 20 27.273438 C 18.996094 27.273438 18.179688 26.460938 18.179688 25.453125 L 18.179688 18.179688 C 18.179688 17.175781 18.996094 16.363281 20 16.363281 C 21.003906 16.363281 21.820312 17.175781 21.820312 18.179688 Z M 21.820312 25.453125 "/>
            <g id="surface1">
        </g>
    </svg>
`;

/* eslint-enable @stylistic/max-len */

/** Schedule template. */
export function scheduleTemplate(this: MSSchedule): TemplateResult {
    return html`
        <style>
            ${calendarCss}
        </style>
        <style>
            ${toastCss}
        </style>
        <div style="width: 100%" class="calendar-container">
            <div class="calendar-sm-container">
                <div class="calendar-sm-nav">
                    <select
                        id="calendars-block"
                        placeholder="Список расписаний"
                        options-variant="icon"
                        @change=${this.onScheduleChange.bind(this)}
                    >
                        ${this.schedules.map(
                            schedule => html`
                                <option
                                    class=${classMap({
                                        // eslint-disable-next-line @typescript-eslint/naming-convention
                                        "schedule-option_disabled": !(schedule.isLocked ?
                                            schedule.isEnabledFb :
                                            schedule.isEnabledHmi),
                                        // eslint-disable-next-line @typescript-eslint/naming-convention
                                        "schedule-option_selected": schedule.scheduleId === this.selectedSchedule?.scheduleId,
                                    })}
                                    value=${schedule.scheduleId}
                                    .selected=${this.selectedSchedule?.scheduleId === schedule.scheduleId}
                                >
                                    ${schedule.name}
                                </option> 
                            `,
                        )}
                    </select>
                </div>
                <div class="calendar-sm-wrapper">
                    <fw-tooltip
                        class="holidays-button-tooltip"
                        placement="right-end"
                        trigger="hover"
                        content="Назначить определенные даты рабочими/нерабочими днями"
                    >
                        <fw-button @fwClick=${this.onWeekendsButtonClick.bind(this)} class="holidays-button">Нерабочие дни</fw-button>
                    </fw-tooltip>
                    <div id="calendar-sm"></div>

                    <div class="controls">
                        <p>Расписание</p>

                        <div class="controls-row">
                            <fw-button id="add-schedule-button" color="secondary" style="flex: 1;">Добавить</fw-button>
                        </div>
                    </div>
                </div>
                <div class="calendar-sm-container__bottom">
                    ${
                        this.taskEditedWarningType !== "none" ?
                            html`
                            <div class="task-edited-warning">
                                ${warning}
                                ${this.taskEditedWarningType === "single" ?
                                    "Редактируемое событие было изменено другим пользователем" :
                                    "Редактируемый ряд событий был изменен другим пользователем"}
                                <button
                                    class="task-edited-warning__close-button"
                                    @click=${this.handleTaskEditedWarningCloseButtonClick.bind(this)}
                                >
                                    <fw-icon name="cross" size=14 color="#EFA0A3"></fw-icon>
                                </button>
                            </div>
                        ` :
                            nothing
                    }
                    <div class="calendar-activate">
                        <div class="activation-lock" @click=${this.handleScheduleActivationLockChange.bind(this)}>
                            ${this.isScheduleActivationLocked ?
                                lockClosed :
                                lockOpened}
                        </div>
                        <fw-checkbox
                            .checked=${this.isScheduleEnabled}
                            .value=${true}
                            .disabled=${this.isScheduleActivationLocked}
                            @fwChange=${(event: CheckboxChangeEvent<boolean>) => {
                                this.handleScheduleEnabledChange(event.detail.meta.checked);
                            }}
                        >
                            Активировать расписание
                        </fw-checkbox>
                    </div>
                </div>
            </div>
            <div class="calendar-lg-container">
                <div class="calendar-lg-nav">
                    ${this.isScheduleEnabled ?
                        nothing :
                        html` <div class="calendar-disabled">Расписание неактивно</div> `}
                    <ul id="calendar-view-container">
                        <li class="active" view="today">Сегодня</li>
                        <li view="day">День</li>
                        <li view="week">Неделя</li>
                        <li view="workweek">Рабочая неделя</li>
                        <li view="month">Месяц</li>
                    </ul>
                </div>
                <div class="calendar-main">
                    <div class="calendar-header-container">
                        <div class="arrow left" @click=${this.onPrevButtonClick.bind(this)}>${arrow}</div>
                        <div id="time-header">${this.headerTime}</div>
                        <div class="arrow right" @click=${this.onNextButtonClick.bind(this)}>${arrow}</div>
                    </div>
                    <div id="calendar-lg" style="width: 100%"></div>
                </div>
            </div>
        </div>
    `;
}
